<template>
  <div class="payment-block">
    <h3>{{ paymentMethod === 'Manual' ? $t('payment.payment.make_booking') : $t('payment.payment.make_payment') }}</h3>
    <div class="payment-frame">
      <ul class="radio-list list-unstyled" v-if="showPaypal && paymentMethod !== 'Manual'">
        <li>
          <input type="radio" id="card" name="method" @click="updatePayment('Checkout')" :checked="paymentMethod === 'Checkout'" />
          <label for="card">{{ $t('payment.payment.card') }}</label>
        </li>
        <li>
          <input type="radio" id="paypal" name="method" @click="updatePayment('Paypal')" :checked="paymentMethod === 'Paypal'" />
          <label for="paypal">
            <img class="ml-0" :src="`${cdn}/images/pp-logo-100px.png`" alt="PayPal">
          </label>
        </li>
      </ul>
      <div class="pay-heading">
        <strong class="title">
          <span v-if="credits > 0" class="d-block mb-2 small">{{ $t('payment.basket.customer_credits_used') }}: {{ currency }}{{ credits > total ? total : credits.toFixed(2) }}<br></span>
          {{ $t('payment.payment.total_to_pay') }}: {{ currency }}{{ basketTotal }}
        </strong>
        <ul class="pay-list list-unstyled">
          <li>
            <img :src="`${cdn}/images/img37.png`" alt="maestro" />
          </li>
          <li>
            <img :src="`${cdn}/images/img38.png`" alt="visa" />
          </li>
          <li>
            <img :src="`${cdn}/images/img39.png`" alt="amex" />
          </li>
          <li>
            <img :src="`${cdn}/images/img40.png`" alt="visa electron" />
          </li>
          <li>
            <img :src="`${cdn}/images/img41.png`" alt="maestro" />
          </li>
        </ul>
      </div>
      <div class="mt-5 mb-4" v-show="paymentMethod === 'Checkout'">
        <form id="payment-form" method="POST" action="https://merchant.com/charge-card">

          <label for="card-number">{{ $t('payment.card.card_number') }}</label>
          <div class="input-container card-number">
            <div class="icon-container">
              <img id="icon-card-number" :src="cardImage" alt="PAN" />
            </div>
            <div class="card-number-frame"></div>
            <div class="icon-container payment-method show" v-if="methodImage.length > 0">
              <img id="logo-payment-method" :src="methodImage" />
            </div>
            <div class="icon-container">
              <img id="icon-card-number-error" :src="`${cdn}/images/error.svg`" />
            </div>
          </div>

          <div class="date-and-code">
            <div>
              <label for="expiry-date">{{ $t('payment.card.expiry_date') }}</label>
              <div class="input-container expiry-date">
                <div class="icon-container">
                  <img id="icon-expiry-date" :src="`${cdn}/images/exp-date.svg`" :alt="$t('payment.card.expiry_date')" />
                </div>
                <div class="expiry-date-frame"></div>
                <div class="icon-container">
                  <img id="icon-expiry-date-error" :src="`${cdn}/images/error.svg`" />
                </div>
              </div>
            </div>

            <div>
              <label for="cvv">{{ $t('payment.card.security') }}</label>
              <div class="input-container cvv">
                <div class="icon-container">
                  <img id="icon-cvv" :src="`${cdn}/images/cvv.svg`" alt="CVV" />
                </div>
                <div class="cvv-frame"></div>
                <div class="icon-container">
                  <img id="icon-cvv-error" :src="`${cdn}/images/error.svg`"/>
                </div>
              </div>
            </div>
          </div>

          <div>
            <span class="error-message error-message__card-number">{{ $t('payment.card.errors.card_number') }}</span>
            <span class="error-message error-message__expiry-date">{{ $t('payment.card.errors.expiry_date') }}</span>
            <span class="error-message error-message__cvv">{{ $t('payment.card.errors.cvv') }}</span>
            <span class="payment-error" v-if="paymentError">{{ $t(paymentError) }}.</span>
          </div>

        </form>
      </div>

      <div class="submit-info">

        <!-- submit form -->
        <button
            type="button"
            class="btn btn-primary"
            :disabled="(paymentMethod === 'Paypal' && loading) || (!allowSubmit && paymentMethod === 'Checkout') || inProgress"
            @click="$emit('submit', true)"
        >
          {{ paymentMethod === 'Manual' ? $t('payment.payment.make_booking') : $t('payment.payment.make_payment') }}
        </button>

        <p class="title mt-4 mb-0 terms-and-conditions">
          {{ $t('payment.basket.on_making_payment') }}
          <a :href="terms" target="_blank">{{ $t('payment.basket.terms') }}.</a>
        </p>

        <ul class="method-list list-unstyled">
          <li>
            <img :src="`${cdn}/images/img43.png`" alt="norton" />
          </li>
          <li>
            <img :src="`${cdn}/images/img44.png`" alt="security metrics" />
          </li>
        </ul>
      </div>

      <!-- opt in-->
      <div class="opt-in-wrapper mt-3 px-sm-4 mb-0">
        <input type="checkbox" id="opt_in" v-model="opt_in" :true-value="false" :false-value="true" />
        <label for="opt_in" class="sign-checkbox opt-out-text">
          {{ $t('payment.customer.why_sign_up') }}
        </label>
      </div>

    </div>

    <account-create @submit="$emit('submit', false)" />
  </div>
</template>

<script>
import { get, sync } from "vuex-pathify";
import mixins from "@/mixins";
import checkout from "@/utils/checkout";
import AccountCreate from "./account-create";

export default {
  name: "payment-details",
  mixins: [checkout.checkout, mixins.globals],
  components: { AccountCreate },
  data() {
    return {
      allowSubmit: false
    }
  },
  computed: {
    total: get("cart/total"),
    paymentMethod: sync("payment/method"),
    opt_in: sync("customer/opt_in"),
    paymentError: sync("payment/error"),
    accountCreate: sync("modals/accountCreate"),
    credits: get("customer/credits"),
    inProgress: sync("payment/inProgress"),
    basketTotal() {
      let amount = this.credits > 0 ? (this.total - this.credits) : this.total;
      return parseFloat(amount > 0 ? amount : 0).toFixed(2);
    }
  },
  props: {
    loading: { type: Boolean, default: false }
  },
  watch: {
    basketTotal(value) {
      if(value == 0 && this.paymentMethod !== 'Manual') this.paymentMethod = 'Manual';
      if(value > 0 && this.paymentMethod == 'Manual') this.paymentMethod = 'Checkout';
    }
  },
  methods: {
    updatePayment(value) {
      this.paymentMethod = value;
    }
  },
  created() {
    if(!this.showPaypal && this.paymentMethod === 'Paypal') {
      this.paymentMethod = 'Checkout';
    }

    if(this.$route.query.status == 'failed') {

      this.paymentError = this.$t('payment.payment.error.failed');

      this.$nextTick(() => {
         let requiredElement = document.getElementsByClassName("payment-error")[0];
         requiredElement.scrollIntoView({ block: "end" });
      });
    }
  },
  mounted() {
    if(this.basketTotal == 0) this.paymentMethod = 'Manual';
    if(this.basketTotal > 0 && this.paymentMethod == 'Manual') this.paymentMethod = 'Checkout';

    // reset opt_in on load
    this.opt_in = true;

    /* eslint-disable */
    this.$loadScript("https://cdn.checkout.com/js/framesv2.min.js")
    .then(() => {

      Frames.init({
        publicKey: process.env.VUE_APP_CHECKOUT_PUBLIC,
        cardValidationChanged: () => {
          this.allowSubmit = Frames.isCardValid();
        }
      })

      Frames.addEventHandler(
        Frames.Events.FRAME_VALIDATION_CHANGED,
        this.onValidationChanged
      );

      Frames.addEventHandler(
        Frames.Events.PAYMENT_METHOD_CHANGED,
        this.paymentMethodChanged
      );
    });
    /* eslint-enable */
  }
};
</script>
